export default {
  module: {
    key: 'bbs/extra-nav',
    id: 'bbs-extra-nav',
    icon: 'fab fa-wexin',
  },
  setting: {
    navList: 'bbs-extra-nav.navList',
  },
};
